import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import EN from "@/constants/en";

const Projects = () => {
    const aiProjects = EN.PROJECTS_AI;
    const paidProjects = EN.PROJECTS_PAID;
    const ventureProjects = EN.PROJECTS_VENTURES;

    return (
        <>
            <section id="projects" className="section">
                <div className="container-custom">
                    <h2 className="section-title">{EN.PROJECTS_SECTION_TITLE}</h2>

                    <h3 className="text-xl font-semibold mb-4">{EN.PROJECTS_AI_SECTION_TITLE}</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                        {aiProjects.map((project, index) => (
                            <Card key={index} className="h-full hover:shadow-md transition-shadow">
                                <CardHeader>
                                    <CardTitle className="text-lg">{project.title}</CardTitle>
                                    <Badge variant="outline" className="text-xs w-fit">
                                        {project.company}
                                    </Badge>
                                </CardHeader>
                                <CardContent>
                                    <CardDescription className="text-sm mb-4">{project.description}</CardDescription>
                                    <Button variant="outline" size="sm" asChild>
                                        <Link to={project.link}>{EN.PROJECTS_VIEW_DETAILS}</Link>
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </div>

                    <h3 className="text-xl font-semibold mb-4">{EN.PROJECTS_PLATFORM_SECTION_TITLE}</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {paidProjects.map((project, index) => (
                            <Card key={index} className="h-full hover:shadow-md transition-shadow">
                                <CardHeader>
                                    <CardTitle className="text-lg">{project.title}</CardTitle>
                                    <Badge variant="outline" className="text-xs w-fit">
                                        {project.company}
                                    </Badge>
                                </CardHeader>
                                <CardContent>
                                    <CardDescription className="text-sm mb-4">{project.description}</CardDescription>
                                    <Button variant="outline" size="sm" asChild>
                                        <Link to={project.link}>{EN.PROJECTS_VIEW_DETAILS}</Link>
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>

            <section id="ventures" className="section bg-secondary/30">
                <div className="container-custom">
                    <h2 className="section-title">{EN.PROJECTS_VENTURE_SECTION_TITLE}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {ventureProjects.map((project, index) => (
                            <Card key={index} className="h-full hover:shadow-md transition-shadow">
                                <CardHeader>
                                    <div className="flex items-start justify-between">
                                        <CardTitle className="text-lg">{project.title}</CardTitle>
                                        <Badge variant="secondary" className="text-xs">
                                            {project.category}
                                        </Badge>
                                    </div>
                                </CardHeader>
                                <CardContent>
                                    <CardDescription className="text-sm mb-4">{project.description}</CardDescription>
                                    <Button variant="outline" size="sm" asChild>
                                        <Link to={project.link}>{EN.PROJECTS_VIEW_DETAILS}</Link>
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Projects;
